import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import AlertsComp from '../../../Components/AlertsComp';


export default function TechnicianWeeklyReports(props) {
    const [technicianNames, setTechnicianNames] = useState([]);
    const [Alerts, setAlerts] = useState('');
    useEffect(() => {
        if (props?.technicianweeklyData?.data?.data?.length) {
            const technicianNames = Object.keys(props?.technicianweeklyData?.data?.data[0]).filter(key => key !== 'date');
            setTechnicianNames(technicianNames);
        } else {
            setTechnicianNames([]);
        }
    }, [props?.technicianweeklyData])
    const downloadCsv = () => {
        const csvContent = [];
        const headers = ['Date', ...technicianNames];
        csvContent.push(headers);
        props?.technicianweeklyData?.data?.data?.forEach((entry) => {
            const row = [entry.date];
            technicianNames.forEach((tech) => {
                row.push(entry[tech] !== undefined ? entry[tech] : '');
            });
            csvContent.push(row);
        });
        if (csvContent.length > 1) {
            const csvString = csvContent.map(row =>
                row.map(val => `"${val}"`).join(',')
            ).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'TechnicianWeeklyReport.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            setAlerts(<AlertsComp show={true} variant="danger" msg={'No data available for download.'} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />);
            }, 2500);
        }
    };
    return (
        <div>
            {Alerts}
            <div className="col-12 mt-3">
                <div className="greyBox" style={{ height: "100%" }}>
                    <div className='row'>
                        <div className='col-md-8'>
                            <h5 className="fw-bold ps-2 mb-0">Technician Tickets Weekly Report</h5>
                        </div>
                        <div className='col-4 text-end'>
                            <label className='cursor-pointer text-decoration-underline' onClick={downloadCsv}>Download Tech Work Summary</label>
                        </div>
                    </div>
                    <hr className="my-2" />
                    <div className="w-100 mx-2" style={{ overflowX: 'auto' }}>
                        <div style={{ display: 'inline-flex', minWidth: 'max-content', width: '100%' }} className="flex-column">
                            <div className="d-flex border-bottom fw-bold">
                                {technicianNames.length !== 0 &&
                                    <div className="px-2 py-3 text-center position-sticky start-0" style={{ width: 120, backgroundColor: "#f7f8fa" }}>Date</div>
                                }
                                {technicianNames.map((tech, idx) => (
                                    <div className="px-2 py-3 text-center text-wrap" style={{ width: 120 }} key={idx}>{tech}</div>
                                ))}
                            </div>

                            {props?.technicianweeklyData?.loader
                                ? <div className="text-center p-2">
                                    <img src="/images/loder.svg" style={{ width: "30px" }} />
                                </div>
                                : props?.technicianweeklyData?.data?.data?.length !== 0 ?
                                    props?.technicianweeklyData?.data?.data?.map((entry, rowIndex) => (
                                        <div className="d-flex border-top" key={rowIndex}>
                                            <div className="px-2 py-2 text-center position-sticky start-0" style={{ width: 120, backgroundColor: "#f7f8fa" }}>{entry.date}</div>
                                            {technicianNames.map((tech, colIndex) => (
                                                <div className="px-2 py-2 text-center" style={{ width: 120 }} key={colIndex}>
                                                    {entry[tech]}
                                                </div>
                                            ))}
                                        </div>
                                    ))
                                    :
                                    <div className="text-center p-2 border-top">No Record Found</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
